import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import products from "../../assets/store/products";
import Navbar from "../../components/navbar/Navbar";
import PageBreakDefault from "../../components/pageBreaks/PageBreakDefault";
import FooterMain from "../../components/section/footer/FooterMain";
import Footer from "../../components/section/footer/FooterSection";
import MenuSpacer from "../../components/spacer/MenuSpacer";
import ProductDetails from "./componets/ProductDetails";
import RecommendationSection from "./componets/RecommendationSection";

const Wrapper = styled.div``;

function ProductPage() {
  const { slug } = useParams();
  const [product, setProduct] = useState();
  const [recommendedProducts, setRecomendedProducts] = useState();
  useEffect(() => {
    const getProductBySlug = () => {
      const fetchedProduct = products.find((product) => product.slug === slug);
      setProduct(fetchedProduct);
      const recommendedProducts = products.filter(
        (product) =>
          product.material === fetchedProduct.material &&
          product.slug !== fetchedProduct.slug
      );

      setRecomendedProducts(recommendedProducts);
    };
    getProductBySlug();
  }, [slug]);

  return (
    <Wrapper>
      <Navbar />
      <MenuSpacer />
      {product && (
        <>
          <ProductDetails product={product} />
          <PageBreakDefault />
          <RecommendationSection recommendedProducts={recommendedProducts} />
        </>
      )}
      <FooterMain />
      <Footer />
    </Wrapper>
  );
}

export default ProductPage;
